import { humanize } from '../../lib/format';

interface AmenitiesFilterProps {
  options: string[];
  selected: string[];
  onChange: (next: string[]) => void;
}

/** Amenity multi-select (AND semantics). Options come from the result-set facet. */
export function AmenitiesFilter({ options, selected, onChange }: AmenitiesFilterProps) {
  if (options.length === 0) return null;

  function toggle(a: string) {
    onChange(selected.includes(a) ? selected.filter((x) => x !== a) : [...selected, a]);
  }

  return (
    <fieldset className="border-0 p-0">
      <legend className="font-serif text-lg font-bold text-ink">Amenities</legend>
      <ul className="mt-3 space-y-2.5">
        {options.map((a) => (
          <li key={a}>
            <label className="flex cursor-pointer items-center gap-2.5 text-sm text-ink-soft">
              <input
                type="checkbox"
                checked={selected.includes(a)}
                onChange={() => toggle(a)}
                className="h-4 w-4 rounded border-sand accent-clay"
              />
              <span>{humanize(a)}</span>
            </label>
          </li>
        ))}
      </ul>
    </fieldset>
  );
}
